const messages = {
  browserSettingsError:
    "Aby kontynuować korzystanie ze strony, włącz cookies i localStorage w swojej przeglądarce.<br>To continue using our website, please enable cookies and localStorage in your browser.",
};

export default messages;
